var _rect, _path, _g, _path2, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiEnterpriseInsightsPlatform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 832,
    viewBox: "0 0 1280 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "#221D30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 644.094C123.25 772.142 661.769 868.504 603.79 628.91C569.864 488.715 181.719 479.57 307.5 347.5C447.5 200.5 830.118 651.179 1006.72 527.686C1227.53 373.275 719.51 337.385 762.266 167.329C805.022 -2.72776 1074 133.933 1074 133.933",
    stroke: "url(#paint0_linear_939_3810)",
    strokeWidth: 25,
    strokeDasharray: "50 25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_939_3810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 790.609,
    y: 429,
    width: 406.133,
    height: 228.677,
    transform: "rotate(2.91 790.609 429)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.349,
    y: 434.247,
    width: 396.133,
    height: 218.677,
    transform: "rotate(2.91 795.349 434.247)",
    stroke: "#BBC2D1",
    strokeWidth: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M916.663 640.614L807.029 635.043L816.289 452.815L925.923 458.386L916.663 640.614ZM1036.88 646.723L927.248 641.152L936.508 458.924L1046.14 464.495L1036.88 646.723ZM1157.1 652.831L1047.47 647.26L1056.73 465.033L1166.36 470.604L1157.1 652.831Z",
    fill: "#F1F3F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M898.051 628.884L820.224 624.929L820.449 620.5L898.276 624.455L898.051 628.884ZM1018.27 634.993L940.443 631.038L940.668 626.609L1018.49 630.564L1018.27 634.993ZM1138.49 641.101L1060.66 637.147L1060.89 632.718L1138.71 636.673L1138.49 641.101ZM901.699 619.554L820.71 615.439L820.935 611.009L901.924 615.124L901.699 619.554ZM1142.13 631.771L1061.14 627.656L1061.36 623.227L1142.35 627.342L1142.13 631.771ZM1021.93 625.662L940.935 621.547L941.16 617.118L1022.15 621.233L1021.93 625.662ZM887.058 608.026L821.253 604.682L821.575 598.355L887.38 601.699L887.058 608.026ZM1007.28 614.134L941.472 610.791L941.794 604.464L1007.6 607.808L1007.28 614.134ZM1127.49 620.243L1061.68 616.899L1062 610.572L1127.81 613.916L1127.49 620.243ZM1020.43 592.6L942.599 588.646L942.825 584.216L1020.65 588.17L1020.43 592.6ZM1140.64 598.709L1062.81 594.754L1063.04 590.324L1140.86 594.279L1140.64 598.709ZM900.208 586.49L822.382 582.536L822.607 578.107L900.433 582.062L900.208 586.49ZM903.856 577.161L822.866 573.045L823.091 568.616L904.081 572.732L903.856 577.161ZM1024.07 583.269L943.077 579.154L943.302 574.725L1024.29 578.84L1024.07 583.269ZM1144.29 589.378L1063.29 585.262L1063.52 580.833L1144.51 584.949L1144.29 589.378ZM1129.64 577.85L1063.84 574.507L1064.16 568.179L1129.97 571.523L1129.64 577.85ZM889.214 565.632L823.409 562.288L823.731 555.961L889.536 559.304L889.214 565.632ZM1009.43 571.741L943.628 568.397L943.95 562.07L1009.75 565.414L1009.43 571.741ZM902.356 544.098L824.53 540.143L824.755 535.714L902.581 539.669L902.356 544.098ZM1022.58 550.207L944.757 546.252L944.982 541.822L1022.81 545.777L1022.58 550.207ZM1142.79 556.315L1064.96 552.36L1065.18 547.931L1143.01 551.886L1142.79 556.315ZM1026.22 540.877L945.233 536.761L945.458 532.331L1026.45 536.447L1026.22 540.877ZM906.012 534.767L825.022 530.652L825.247 526.223L906.237 530.338L906.012 534.767ZM1146.44 546.984L1065.45 542.869L1065.68 538.44L1146.67 542.555L1146.44 546.984ZM891.362 523.239L825.558 519.896L825.879 513.568L891.684 516.912L891.362 523.239ZM1131.8 535.457L1066 532.113L1066.32 525.785L1132.12 529.129L1131.8 535.457ZM1011.6 529.348L945.792 526.004L946.114 519.677L1011.92 523.021L1011.6 529.348ZM840.967 478.81C848.306 479.183 854.053 483.452 853.805 488.344C853.556 493.236 847.405 496.899 840.067 496.527C832.729 496.154 826.981 491.886 827.23 486.994C827.478 482.101 833.629 478.437 840.967 478.81ZM961.186 484.919C968.524 485.292 974.272 489.56 974.024 494.452C973.775 499.344 967.624 503.008 960.286 502.635C952.947 502.262 947.2 497.994 947.448 493.101C947.697 488.209 953.848 484.546 961.186 484.919ZM1081.41 491.028C1088.75 491.401 1094.5 495.669 1094.25 500.561C1094 505.453 1087.85 509.117 1080.51 508.745C1073.17 508.372 1067.43 504.103 1067.68 499.211C1067.92 494.319 1074.07 490.655 1081.41 491.028ZM908.422 487.313L862.233 484.966L862.458 480.536L908.648 482.883L908.422 487.313ZM1028.63 493.421L982.443 491.074L982.668 486.644L1028.86 488.991L1028.63 493.421ZM1148.85 499.53L1102.66 497.183L1102.89 492.753L1149.08 495.1L1148.85 499.53ZM841.81 462.359C845.654 462.554 848.611 465.829 848.416 469.673C848.221 473.516 844.947 476.475 841.103 476.28C837.259 476.084 834.301 472.809 834.497 468.965C834.692 465.122 837.966 462.164 841.81 462.359ZM962.021 468.467C965.865 468.663 968.822 471.937 968.627 475.781C968.432 479.625 965.158 482.582 961.314 482.387C957.47 482.192 954.512 478.918 954.708 475.074C954.903 471.23 958.177 468.272 962.021 468.467ZM1082.25 474.577C1086.09 474.772 1089.05 478.046 1088.85 481.89C1088.66 485.734 1085.38 488.691 1081.54 488.496C1077.7 488.301 1074.74 485.027 1074.93 481.183C1075.13 477.339 1078.4 474.381 1082.25 474.577ZM896.179 478.444L862.644 476.74L862.966 470.412L896.501 472.116L896.179 478.444ZM1016.41 484.553L982.871 482.849L983.192 476.521L1016.73 478.225L1016.41 484.553ZM1136.62 490.661L1103.08 488.957L1103.4 482.629L1136.94 484.333L1136.62 490.661Z",
    fill: "#BBC2D1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_939_3810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 531.515L475.556 471L510 711.515L87.4445 772.03L53 531.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.342 707.273L91.6846 766.371L58.6572 535.755L471.314 476.657L504.342 707.273Z",
    stroke: "#BBC2D1",
    strokeWidth: 10
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.799 636L192.306 648.107L181.914 575.588L266.407 563.481L276.799 636ZM180.324 649.823L95.1649 662.026L84.7734 589.508L169.933 577.305L180.324 649.823ZM374.596 621.985L290.102 634.092L279.711 561.574L364.204 549.467L374.596 621.985ZM471.731 608.066L386.571 620.269L376.18 547.751L461.339 535.548L471.731 608.066Z",
    fill: "#F1F3F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M186.819 714.074L104.322 725.895L103.654 721.239L186.152 709.417L186.819 714.074ZM283.952 700.155L201.455 711.977L200.787 707.32L283.285 695.499L283.952 700.155ZM381.756 686.14L299.259 697.962L298.592 693.305L381.089 681.484L381.756 686.14ZM478.132 671.652L395.634 683.473L394.966 678.817L477.465 666.995L478.132 671.652ZM182.07 704.571L102.9 715.916L102.232 711.258L181.403 699.914L182.07 704.571ZM279.204 690.652L200.032 701.996L199.365 697.34L278.537 685.995L279.204 690.652ZM376.992 676.639L297.822 687.984L297.154 683.326L376.325 671.982L376.992 676.639ZM473.375 662.149L394.205 673.494L393.537 668.836L472.708 657.492L473.375 662.149ZM273.117 681.34L198.602 692.017L197.935 687.36L272.449 676.682L273.117 681.34ZM370.914 667.326L296.399 678.004L295.732 673.346L370.246 662.669L370.914 667.326ZM175.976 695.259L101.462 705.936L100.794 701.279L175.309 690.602L175.976 695.259ZM467.289 652.837L392.775 663.515L392.107 658.857L466.622 648.18L467.289 652.837ZM182.522 684.135L100.025 695.957L99.3576 691.3L181.855 679.479L182.522 684.135ZM279.663 670.216L197.165 682.037L196.498 677.381L278.995 665.559L279.663 670.216ZM377.46 656.202L294.962 668.023L294.295 663.367L376.792 651.546L377.46 656.202ZM473.835 641.713L391.337 653.535L390.67 648.878L473.168 637.057L473.835 641.713ZM164.849 674.448L98.3187 683.981L97.3654 677.328L163.896 667.795L164.849 674.448ZM261.982 660.529L195.452 670.063L194.498 663.41L261.029 653.876L261.982 660.529ZM359.787 646.514L293.256 656.048L292.303 649.395L358.833 639.862L359.787 646.514ZM456.161 632.026L389.631 641.559L388.677 634.906L455.208 625.373L456.161 632.026ZM155.669 553.549L81.1546 564.226L80.2011 557.573L154.715 546.895L155.669 553.549Z",
    fill: "#BBC2D1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_939_3810)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_939_3810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.891,
    y: 76.1213,
    width: 495.338,
    height: 325.45,
    transform: "rotate(-2.13476 186.891 76.1213)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.68,
    y: 97.394,
    width: 495.338,
    height: 304.162,
    transform: "rotate(-2.13476 187.68 97.394)",
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.625 85.2137C305.457 80.6951 308.983 76.8954 313.502 76.727L617.453 65.397C621.972 65.2285 625.772 68.7551 625.94 73.2737L628.868 151.818C629.036 156.337 625.51 160.137 620.991 160.305L308.858 171.94L305.625 85.2137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.453,
    y: 118.439,
    width: 265.272,
    height: 4.0937,
    transform: "rotate(-2.13476 315.453 118.439)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.18,
    y: 84.4849,
    width: 241.529,
    height: 4.0937,
    transform: "rotate(-2.13476 314.18 84.4849)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.062,
    y: 134.802,
    width: 241.529,
    height: 4.0937,
    transform: "rotate(-2.13476 316.062 134.802)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.789,
    y: 100.849,
    width: 276.325,
    height: 4.0937,
    transform: "rotate(-2.13476 314.789 100.849)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.664,
    y: 151.166,
    width: 276.325,
    height: 4.0937,
    transform: "rotate(-2.13476 316.664 151.166)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.883,
    y: 76.3032,
    width: 283.694,
    height: 4.0937,
    transform: "rotate(-2.13476 313.883 76.3032)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.75,
    y: 126.621,
    width: 283.694,
    height: 4.0937,
    transform: "rotate(-2.13476 315.75 126.621)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.492,
    y: 92.6667,
    width: 297.203,
    height: 4.0937,
    transform: "rotate(-2.13476 314.492 92.6667)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.375,
    y: 142.985,
    width: 297.203,
    height: 4.0937,
    transform: "rotate(-2.13476 316.375 142.985)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.094,
    y: 109.03,
    width: 265.272,
    height: 4.0937,
    transform: "rotate(-2.13476 315.094 109.03)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.977,
    y: 159.348,
    width: 265.272,
    height: 4.0937,
    transform: "rotate(-2.13476 316.977 159.348)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.883,
    y: 97.9089,
    width: 105.591,
    height: 303.573,
    transform: "rotate(-2.13476 187.883 97.9089)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.172 234.121C311.004 229.602 314.53 225.803 319.049 225.634L623 214.304C627.519 214.136 631.318 217.662 631.487 222.181L635.269 323.634C635.437 328.153 631.91 331.953 627.392 332.121L315.259 343.756L311.172 234.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.586 187.548C494.418 183.029 497.944 179.23 502.463 179.061L666.098 172.962C670.616 172.793 674.416 176.32 674.584 180.838L675.103 194.747L503.286 201.152C498.768 201.32 494.968 197.794 494.8 193.275L494.586 187.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.836,
    y: 359.302,
    width: 365.159,
    height: 27.0185,
    rx: 8.18741,
    transform: "rotate(-2.13476 315.836 359.302)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.929,
    cy: 359.733,
    r: 9.00615,
    transform: "rotate(-2.13476 666.929 359.733)",
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.213 358.983L666.76 355.233M666.76 355.233L670.576 358.708M666.76 355.233L667.08 363.824",
    stroke: "white",
    strokeWidth: 1.63748
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.336,
    y: 183.833,
    width: 153.923,
    height: 4.0937,
    transform: "rotate(-2.13476 506.336 183.833)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.648,
    y: 192.014,
    width: 104.799,
    height: 4.0937,
    transform: "rotate(-2.13476 506.648 192.014)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.281,
    y: 274.71,
    width: 32.7496,
    height: 4.91245,
    transform: "rotate(-2.13476 321.281 274.71)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.828,
    y: 272.453,
    width: 32.7496,
    height: 4.91245,
    transform: "rotate(-2.13476 381.828 272.453)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.281,
    y: 270.013,
    width: 32.7496,
    height: 4.91245,
    transform: "rotate(-2.13476 447.281 270.013)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.867,
    y: 267.68,
    width: 32.7496,
    height: 4.91245,
    transform: "rotate(-2.13476 509.867 267.68)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.461,
    y: 265.347,
    width: 32.7496,
    height: 4.91245,
    transform: "rotate(-2.13476 572.461 265.347)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.82,
    y: 289.396,
    width: 40.937,
    height: 4.91245,
    transform: "rotate(-2.13476 321.82 289.396)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.367,
    y: 287.139,
    width: 40.937,
    height: 4.91245,
    transform: "rotate(-2.13476 382.367 287.139)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.828,
    y: 284.699,
    width: 40.937,
    height: 4.91245,
    transform: "rotate(-2.13476 447.828 284.699)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.414,
    y: 282.366,
    width: 40.937,
    height: 4.91245,
    transform: "rotate(-2.13476 510.414 282.366)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 280.033,
    width: 40.937,
    height: 4.91245,
    transform: "rotate(-2.13476 573 280.033)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.531,
    y: 308.214,
    width: 37.2527,
    height: 4.91245,
    transform: "rotate(-2.13476 322.531 308.214)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.078,
    y: 305.957,
    width: 37.2527,
    height: 4.91245,
    transform: "rotate(-2.13476 383.078 305.957)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.531,
    y: 303.517,
    width: 37.2527,
    height: 4.91245,
    transform: "rotate(-2.13476 448.531 303.517)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.117,
    y: 301.184,
    width: 37.2527,
    height: 4.91245,
    transform: "rotate(-2.13476 511.117 301.184)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.703,
    y: 298.851,
    width: 37.2527,
    height: 4.91245,
    transform: "rotate(-2.13476 573.703 298.851)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.227,
    y: 327.032,
    width: 42.5745,
    height: 4.91245,
    transform: "rotate(-2.13476 323.227 327.032)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.773,
    y: 324.775,
    width: 42.5745,
    height: 4.91245,
    transform: "rotate(-2.13476 383.773 324.775)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.227,
    y: 322.335,
    width: 42.5745,
    height: 4.91245,
    transform: "rotate(-2.13476 449.227 322.335)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.82,
    y: 320.002,
    width: 42.5745,
    height: 4.91245,
    transform: "rotate(-2.13476 511.82 320.002)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.398,
    y: 317.669,
    width: 42.5745,
    height: 4.91245,
    transform: "rotate(-2.13476 574.398 317.669)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.188,
    y: 298.805,
    width: 43.8026,
    height: 4.91245,
    transform: "rotate(-2.13476 322.188 298.805)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.727,
    y: 296.548,
    width: 43.8026,
    height: 4.91245,
    transform: "rotate(-2.13476 382.727 296.548)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.188,
    y: 294.108,
    width: 43.8026,
    height: 4.91245,
    transform: "rotate(-2.13476 448.188 294.108)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.766,
    y: 291.775,
    width: 43.8026,
    height: 4.91245,
    transform: "rotate(-2.13476 510.766 291.775)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 573.352,
    y: 289.442,
    width: 43.8026,
    height: 4.91245,
    transform: "rotate(-2.13476 573.352 289.442)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.883,
    y: 317.623,
    width: 45.8495,
    height: 4.91245,
    transform: "rotate(-2.13476 322.883 317.623)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.438,
    y: 315.366,
    width: 45.8495,
    height: 4.91245,
    transform: "rotate(-2.13476 383.438 315.366)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.883,
    y: 312.926,
    width: 45.8495,
    height: 4.91245,
    transform: "rotate(-2.13476 448.883 312.926)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 511.469,
    y: 310.594,
    width: 45.8495,
    height: 4.91245,
    transform: "rotate(-2.13476 511.469 310.594)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.055,
    y: 308.26,
    width: 45.8495,
    height: 4.91245,
    transform: "rotate(-2.13476 574.055 308.26)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.656 284.896L621.926 273.704",
    stroke: "#BBC2D1",
    strokeWidth: 0.409371
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.32,
    y: 248.938,
    width: 198.545,
    height: 4.0937,
    transform: "rotate(-2.13476 320.32 248.938)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.859,
    y: 236.665,
    width: 149.011,
    height: 7.36867,
    transform: "rotate(-2.13476 319.859 236.665)",
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.711,
    y: 71.1711,
    width: 495.338,
    height: 26.2409,
    transform: "rotate(-2.13476 186.711 71.1711)",
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-1_939_3810",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.372 71.9931C172.166 66.474 176.474 61.8336 181.993 61.6283L684.824 42.9267C690.343 42.7214 694.984 47.0291 695.189 52.5481L707.628 387.007C707.834 392.526 703.526 397.166 698.007 397.372L195.176 416.073C189.657 416.279 185.016 411.971 184.811 406.452L172.372 71.9931Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.372 71.9931C172.166 66.474 176.474 61.8336 181.993 61.6283L684.824 42.9267C690.343 42.7214 694.984 47.0291 695.189 52.5481L707.628 387.007C707.834 392.526 703.526 397.166 698.007 397.372L195.176 416.073C189.657 416.279 185.016 411.971 184.811 406.452L172.372 71.9931Z",
    stroke: "#221D30",
    strokeWidth: 30,
    mask: "url(#path-68-inside-1_939_3810)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.518,
    y: 61.9998,
    width: 522.994,
    height: 354.049,
    rx: 9.5,
    transform: "rotate(-2.13476 172.518 61.9998)",
    stroke: "black",
    shapeRendering: "crispEdges"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.81 182.453C1080.6 195.151 1091.4 207.849 1102.19 220.547C1104.25 218.457 1106.31 216.367 1108.36 214.277C1145.38 176.655 1182.39 139.034 1219.4 101.413C1221.46 99.3227 1223.52 97.2326 1225.57 95.1425C1221.52 90.3808 1217.48 85.6192 1213.43 80.8575C1211.03 82.5507 1208.64 84.244 1206.25 85.9373C1163.16 116.416 1120.07 146.895 1076.99 177.373C1074.59 179.067 1072.2 180.76 1069.81 182.453Z",
    fill: "#00BC56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.67 199.126C1219.56 185.709 1229.44 172.291 1239.33 158.874C1237.12 157.567 1234.9 156.26 1232.69 154.953C1192.86 131.426 1153.03 107.9 1113.2 84.3737C1110.99 83.0666 1108.77 81.7596 1106.56 80.4526C1102.85 85.4842 1099.15 90.5158 1095.44 95.5474C1097.34 97.2737 1099.25 99 1101.15 100.726C1135.42 131.8 1169.69 162.874 1203.96 193.947C1205.86 195.674 1207.77 197.4 1209.67 199.126Z",
    fill: "#00BC56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_939_3810",
    x: 769,
    y: 423,
    width: 437.219,
    height: 269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_939_3810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_939_3810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_939_3810",
    x: 43,
    y: 465,
    width: 477,
    height: 321.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_939_3810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_939_3810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_939_3810",
    x: 162.576,
    y: 36.3454,
    width: 555.708,
    height: 393.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.76974
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.71218
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_939_3810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_939_3810",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_939_3810",
    x1: 791.424,
    y1: 144.097,
    x2: 804.444,
    y2: 897.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BC56",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_939_3810"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 61.5188,
    width: 523.994,
    height: 355.049,
    rx: 10,
    transform: "rotate(-2.13476 172 61.5188)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEnterpriseInsightsPlatform);
export default __webpack_public_path__ + "static/media/AIEnterpriseInsightsPlatform.7a751082228ad7aba3f72048154b8f8a.svg";
export { ForwardRef as ReactComponent };